// Entrance exams relevant to each course category / subcategory
const BY_SUB = {
  "B.E/B.Tech": ["KCET", "COMEDK UGET", "JEE Main", "JEE Advanced", "BITSAT", "VITEEE", "MHT CET", "Uni-GAUGE"],
  "M.Tech": ["GATE", "PGCET"], ME: ["GATE", "PGCET"],
  MBA: ["PGCET", "CAT", "MAT", "XAT", "CMAT", "KMAT", "GMAT"], "PGDM / PG Diploma": ["CAT", "MAT", "XAT", "CMAT", "GMAT"],
  BBA: ["Direct / Merit (12th marks)", "CUET UG", "IPMAT"], BCom: ["Direct / Merit (12th marks)", "CUET UG"],
  "M.E": ["GATE", "PGCET"], "Ph.D": ["UGC NET", "University Entrance Test"], Diploma: ["Direct / Merit (10th marks)", "DCET"],
  MCA: ["PGCET", "NIMCET", "KMAT"], BCA: ["Direct / Merit (12th marks)", "CUET UG"],
  MBBS: ["NEET UG"], BDS: ["NEET UG"], MDS: ["NEET MDS"], MD: ["NEET PG"], MS: ["NEET PG"],
  BAMS: ["NEET UG"], BHMS: ["NEET UG"], BUMS: ["NEET UG"], BNYS: ["NEET UG", "KCET"],
  "B.Arch": ["NATA", "JEE Main Paper 2"], BArch: ["NATA", "JEE Main Paper 2"],
  LLB: ["CLAT", "LSAT India", "KSLU"], "BA LLB": ["CLAT", "AILET", "LSAT India"], LLM: ["CLAT PG"],
  "B.Ed": ["Karnataka B.Ed CET", "Direct / Merit"], BEd: ["Karnataka B.Ed CET", "Direct / Merit"],
};
const BY_CAT = {
  Engineering: ["KCET", "COMEDK UGET", "JEE Main", "JEE Advanced", "GATE", "PGCET"],
  Pharmacy: ["KCET", "NEET UG", "GPAT", "Direct / Merit"],
  "Medicine & Health Sciences": ["NEET UG", "NEET PG", "KCET"], Dental: ["NEET UG", "NEET MDS"],
  Nursing: ["KCET", "NEET UG", "Direct / Merit"], "Para Medical": ["KCET", "Direct / Merit"],
  Management: ["PGCET", "CAT", "MAT", "KMAT", "CMAT", "XAT"], "IT Software": ["PGCET", "NIMCET", "Direct / Merit"],
  Law: ["CLAT", "LSAT India", "AILET"], "Architecture & Planning": ["NATA", "JEE Main Paper 2"],
  Design: ["NID DAT", "UCEED", "NIFT", "CEED"], Fashion: ["NIFT", "NID DAT"],
  "Farm Sciences": ["KCET", "ICAR AIEEA"], "Teaching and Education": ["Karnataka B.Ed CET", "Direct / Merit"],
  "Hotel management": ["NCHMCT JEE", "Direct / Merit"], Aviation: ["Direct / Merit"],
};
const FALLBACK = ["CUET UG", "Direct / Merit (12th marks)"];

export function examsFor(category, sub) {
  const s = (sub || "").replace(/\s+/g, " ").trim();
  const key = Object.keys(BY_SUB).find((k) => k.toLowerCase() === s.toLowerCase());
  return key ? BY_SUB[key] : BY_CAT[category] || FALLBACK;
}
